import { useContext, useEffect, useState } from "react";
import mainContext from "../../../context/mainContext";
import styles from "./style.module.css";
import srcDash from "../../../assets/images/illustrations/dashboard.svg";
import trIcon from "../../../assets/images/icons/TReadingIcon.svg";
import tfIcon from "../../../assets/images/icons/TFocusIcon.svg";
import fsIcon from "../../../assets/images/icons/FreeStyleIcon.svg";
import waIcon from "../../../assets/images/icons/WAIcon.svg";
import newIcon from "../../../assets/images/icons/new.svg";
import lockIcon from "../../../assets/images/icons/lock.svg";
import unlockIcon from "../../../assets/images/icons/unlock.svg";
import { Link, useNavigate } from "react-router-dom";
import GraphDashboard from "../../../components/Common/GraphTabs/GraphDashboard";
import UmooveApi from "../../../components/api/UmooveApi";
import dataContext from "../../../context/dataContext";
import userRequests from "../../../components/api/userRequests";
import Loader from "../../../components/Common/Loader/Loader";

// Creator : Team h
function Dashboard() {
    const navigate = useNavigate();
    const { header: { setPageName, setIsShowHeader }, initCam: { alreadiInit, setAlreadyInit } } = useContext(mainContext);
    const { userDetails, setAssessmentId, assessmentId, setSumOfAssessments } = useContext(dataContext);
    const [loader, setLoader] = useState(true);
    let newAssess = assessmentId?.title ? true : false;
    const [colorOfBtn, setColorOfBtn] = useState({ pushup: false, nearPoint: false, weekly: false, setRate: false })

    useEffect(() => {
        localStorage.setItem("RoundNumber", "0");
        setPageName("dashboard".toUpperCase());
        setIsShowHeader(true);
        UmooveApi.API_stopUmoove().then(() => {
            setAlreadyInit(false); //so when you go forward in pages, the camera will init
        });
        let assessId;
        userRequests.getAssessNSum(userDetails).then(data => {
            setSumOfAssessments(data.sum);
            setAssessmentId(prev => data.assess);
            if (userDetails.assessments.length == 0 && data.assess) {
                setLoader(false);
                navigate("assessments", { replace: true });
            }
            setLoader(false);
        });

        return () => setPageName("");
    }, []);



    if (loader) {
        return (
            <>
                {userDetails?.assessments.length == 0 && <p style={{ padding: "2rem", textAlign: "center" }}>You need complete an assessment please</p>}
                <Loader />
            </>
        );
    }

    const openLink = (to, currentBtn) => {
        setColorOfBtn(prev => ({ pushup: false, nearPoint: false, weekly: false, setRate: false, [currentBtn]: true }));
        setTimeout(() => {
            navigate(to)
        }, 70)
    }
    return (
        <div className={styles.container} style={window.buildType === "iPhone" ? { height: "85dvh", minHeight: "85dvh" } : {}}>
            <div className={styles.graphContainer}>
                <GraphDashboard />
            </div>
            <div className={styles.BtnContainer}>
                <div className={`${styles.btn} two-colored-div-LPM ${styles.LPM} ${colorOfBtn.pushup ? styles.clicked : ""}`} onClick={() => { openLink("/train-reading", "pushup") }}>
                    <img src={trIcon} alt="PUSHUP" />
                    <p>PUSHUP</p>
                </div>
                <div className={`${styles.btn} two-colored-div-CM ${styles.CM} ${colorOfBtn.nearPoint ? styles.clicked : ""}`} onClick={() => { openLink("/train-focus", "nearPoint") }}>
                    <img src={tfIcon} alt="NEAR-POINT" />
                    <p>NEAR-POINT</p>
                </div>
                <div className={`${styles.btn} two-colored-div-WPM ${styles.WPM} ${colorOfBtn.weekly ? styles.clicked : ""}`} onClick={() => { return newAssess ? openLink("/assessments", "weekly") : "" }}>
                    <img className={styles.float_icon} src={newAssess ? unlockIcon : lockIcon} alt="new-test" />
                    <img src={waIcon} alt="WEEKLY MEASURE" />
                    <p>WEEKLY MEASURE</p>
                </div>
                <div className={`${styles.btn} two-colored-div ${colorOfBtn.setRate ? styles.clicked : ""}`} onClick={() => { openLink("/freestyle", "setRate") }}>
                    <img src={fsIcon} alt="SET RATE" />
                    <p>SET RATE</p>
                </div>
            </div>
        </div>
    );
}

export default Dashboard;
